import { Navigate, useLocation, useParams } from "react-router-dom";

export function LegacyRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}

export function LegacyCrmDetailRedirect() {
  const { id } = useParams<{ id: string }>();
  return <LegacyRedirect to={id ? `/clients/${id}` : "/crm"} />;
}

export function LegacyDossierWizardRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/dossiers/${id}` : "/dossiers"} replace />;
}

export function LegacyVaultSourcesRedirect() {
  // Les vues enregistrées du Coffre ont disparu (réduction 2026-08) : les
  // anciennes URLs « sources » atterrissent sur la liste, leurs autres
  // paramètres (`?doc=`…) préservés.
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.delete("view");
  const qs = params.toString();
  return <Navigate to={`/coffre${qs ? `?${qs}` : ""}${location.hash}`} replace />;
}
